/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PerformanceVolumeMonthRow
 */
export interface PerformanceVolumeMonthRow {
  /**
   *
   * @type {string}
   * @memberof PerformanceVolumeMonthRow
   */
  month: string;
  /**
   * Distinct shipments quoted that month, deduplicated by shipment hash.
   * Quoting one shipment on three services counts once.
   *
   * @type {number}
   * @memberof PerformanceVolumeMonthRow
   */
  quoted: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceVolumeMonthRow
   */
  booked: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceVolumeMonthRow
   */
  spend: number;
  /**
   * Wins over every shipment quoted that month. Absent when nothing was
   * quoted — a month with no activity has no rate, and zero would read
   * as losing everything.
   *
   * @type {number}
   * @memberof PerformanceVolumeMonthRow
   */
  winRate?: number;
  /**
   * Average position on the boards this carrier appeared on that month,
   * where 1 is cheapest. Absent when they quoted nothing.
   *
   * @type {number}
   * @memberof PerformanceVolumeMonthRow
   */
  averagePriceRank?: number;
}

/**
 * Check if a given object implements the PerformanceVolumeMonthRow interface.
 */
export function instanceOfPerformanceVolumeMonthRow(
  value: object,
): value is PerformanceVolumeMonthRow {
  if (!("month" in value) || value["month"] === undefined) return false;
  if (!("quoted" in value) || value["quoted"] === undefined) return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("spend" in value) || value["spend"] === undefined) return false;
  return true;
}

export function PerformanceVolumeMonthRowFromJSON(
  json: any,
): PerformanceVolumeMonthRow {
  return PerformanceVolumeMonthRowFromJSONTyped(json, false);
}

export function PerformanceVolumeMonthRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceVolumeMonthRow {
  if (json == null) {
    return json;
  }
  return {
    month: json["month"],
    quoted: json["quoted"],
    booked: json["booked"],
    spend: json["spend"],
    winRate: json["winRate"] == null ? undefined : json["winRate"],
    averagePriceRank:
      json["averagePriceRank"] == null ? undefined : json["averagePriceRank"],
  };
}

export function PerformanceVolumeMonthRowToJSON(
  json: any,
): PerformanceVolumeMonthRow {
  return PerformanceVolumeMonthRowToJSONTyped(json, false);
}

export function PerformanceVolumeMonthRowToJSONTyped(
  value?: PerformanceVolumeMonthRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    month: value["month"],
    quoted: value["quoted"],
    booked: value["booked"],
    spend: value["spend"],
    winRate: value["winRate"],
    averagePriceRank: value["averagePriceRank"],
  };
}
